import { ref } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "host-manage-content"
};
import HostHeader from '@/views/payManage/domain/components/HostHeader.vue';
import HostContent from '@/views/payManage/domain/components/HostContent.vue';
import { defineComponent } from 'vue';
const __default__ = defineComponent({
  name: 'hostManage'
});
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {
    const tableRef = ref(null);
    const headerRef = ref(null);
    const returnSearch = searchObj => {
      var _tableRef$value;
      (_tableRef$value = tableRef.value) === null || _tableRef$value === void 0 || _tableRef$value.searchData(searchObj);
    };
    const resetDimension = key => {
      var _tableRef$value2;
      (_tableRef$value2 = tableRef.value) === null || _tableRef$value2 === void 0 || _tableRef$value2.resetDimension(key);
    };
    const resetTabs = key => {
      var _headerRef$value;
      (_headerRef$value = headerRef.value) === null || _headerRef$value === void 0 || _headerRef$value.changeTabs();
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(HostHeader, {
        ref_key: "headerRef",
        ref: headerRef,
        onReturnSearch: returnSearch,
        onResetDimension: resetDimension
      }, null, 512), _createVNode(HostContent, {
        ref_key: "tableRef",
        ref: tableRef,
        onResetTabs: resetTabs
      }, null, 512)]);
    };
  }
});